import React from 'react' // eslint-disable-line no-unused-vars
import { Collapse } from 'reactstrap';
import { DOWNLOAD_BUTTON, LINK_BUTTON } from '../../constants';
import { CircularProgress } from '@material-ui/core'

class RowCard extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false
    }
  }

  toggle = () => this.setState({ isOpen: !this.state.isOpen })

  getFormattedData = (data, row, rowName, index) => {
    if (!data) {
      return
    }

    if (row.key === DOWNLOAD_BUTTON) {
      return (
        <div>
          <button
            className='btn btn-info btn-rounded patient-download-button'
            id={`download-${data.parent.id}`}
            type='button'
            disabled={data.disableDownload}
            onClick={() => this.props.showDownloadPopupModal(index, data)}
          >
            {
              data.disableDownload
                ? <div className='loading-text-centered'>
                  <span>{this.props.languageContent.download}</span>
                  <span className='loading-progress-centered'><CircularProgress size={20} /></span>
                </div>
                : <React.Fragment>{this.props.languageContent.download}</React.Fragment>
            }
          </button>
        </div>
      )
    }

    if (row.key === LINK_BUTTON) {
      return (
        <div className='download-button-wrapper modal-link-info'>
          <a
            className='btn btn-info btn-rounded patient-download-button'
            href={data.parent.url}
            id={`link-${data.parent.id}`}
            target='_blank'
            rel='noopener noreferrer'
            data-tag='track-exit'
            data-analytics-text='Product Documentation'
          >
            {this.props.languageContent.download}
          </a>
        </div>
      )
    }

    let rowData = data.parent[row.key]
    if (row.isArray) {
      rowData = rowData.join(', ')
    }
    return (
      <div className='row-entry row'>
        <div className='col-5'>{allowBreakOnSlash(rowName)}</div>
        <div className='col-7'>{allowBreakOnSlash(rowData)}</div>
      </div>
    )
  }

  render() {
    const {
      groupedData,
      groupedCardStyle,
      columnNames,
      columnKeys,
      index,
      id,
      searchAuditId } = this.props
    const { isOpen } = this.state

    // Convert column attributes to rows, with first column becoming the card header
    const headerText = allowBreakOnSlash(groupedData[0].parent[columnKeys[0].key])
    const rowNames = columnNames.slice(1)
    const rowKeys = columnKeys.slice(1)

    return (
      <div className='table-card'>
        <div
          id={`${id}-card-${index}-header`}
          className={`row-header ${isOpen && 'is-open'}`}
          onClick={this.toggle}
          role='button'
          aria-expanded={isOpen}
          aria-controls={`${id}-card-${index}-panel`}
        >
          <div>{headerText}</div>
          <div id={`chevron-${id}-${index}`} className={`expand-icon ${isOpen ? 'is-open' : 'is-closed'}`}>
            <Chevron />
          </div>
        </div>
        <Collapse isOpen={this.state.isOpen}>
          <div
            id={`${id}-card-${index}-panel`}
            className='row-content'
            role='region'
            aria-labelledby={`${id}-card-${index}-header`}
          >
            {
              groupedData.map((data, i) =>
                <div
                  id={`${id}-card-${index}-document-${i}`}
                  key={`${id}-card-${index}-document-${i}-${data.parent.id}`}
                  style={i === 0 ? {} : groupedCardStyle}
                >
                  {
                    rowKeys.map((row, j) =>
                      <div
                        id={`${id}-card-${index}-document-${i}-row-${j}`}
                        key={`${id}-card-${index}-document-${i}-row-${j}-${data.parent.id}`}>
                        {this.getFormattedData(data, row, rowNames[j], i)}
                      </div>
                    )}
                </div>
              )}
          </div>
        </Collapse>
      </div>
    )
  }
}

const allowBreakOnSlash = (text) => text ? text.split('/').reduce((a, b) => <React.Fragment>{`${a}/`}<wbr />{b}</React.Fragment>) : ''

const Chevron = () =>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="13" viewBox="0 0 20 13" fill="none">
    <path d="M0.404876 2.40041L10.0042 12.333L19.6035 2.40041C19.8642 2.12969 20.0068 1.76646 19.9998 1.39064C19.9927 1.01481 19.8367 0.657171 19.566 0.396395C19.2952 0.135617 18.932 -0.00693407 18.5562 9.7401e-05C18.1804 0.00712983 17.8227 0.16317 17.5619 0.433892L10.0042 8.25831L2.43806 0.433893C2.17728 0.163171 1.81964 0.00713126 1.44382 9.8897e-05C1.06799 -0.00693251 0.704762 0.135619 0.434041 0.396396C0.16332 0.657173 0.00727936 1.01481 0.000246999 1.39064C-0.00678536 1.76647 0.135766 2.12969 0.396545 2.40041L0.404876 2.40041Z" fill="black" />
  </svg>

export default RowCard



// WEBPACK FOOTER //
// ./src/mi-app/tables/RowCard.js